import { CallAPI } from "../../apiManager/ApiCall";
import {
  getReportURL,
  getMapReportURL,
  getProfStatsURL,
  getStorageSummaryURL,
  getDeviceHostsReportURL,
  getUniversityInsightsURL,
  getCountryConversionURL,
} from "../../apiManager/APIConfig";
import { setReport, setMapReport } from "../../redux/slices/reportSlice";
import { store } from "../../redux/store";

export const GetDashboardReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getReportURL}`,
      method: "GET",
    });
    console.log("pippo response", response);

    if (!response?.status) {
      store.dispatch(setReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

export const GetMapReportCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getMapReportURL}`,
      method: "GET",
    });

    if (response?.status == 200) {
      console.log("pippo response", response);

      store.dispatch(setMapReport(response));
      return response;
    } else {
      return response;
    }
  } catch (error) {
    return { status: 400 };
  }
};

const defaultProfStats = () => ({
  studentsCount: 0,
  attemptsLast7Days: {
    labels: [],
    datasets: { label: "Quiz attempts", data: [] },
  },
  quizSummary: [],
  attendanceHeatmap: [],
  attemptsByWeek: { labels: [], datasets: { label: "Attempts", data: [] } },
  scoreDistribution: { labels: ["0-20%", "20-40%", "40-60%", "60-80%", "80-100%"], datasets: { label: "Attempts", data: [0, 0, 0, 0, 0] } },
  activityByDayOfWeek: { labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], datasets: { label: "Attempts", data: [0, 0, 0, 0, 0, 0, 0] } },
  topStudentsByScore: [],
  attemptsByQuizForPie: { labels: [], datasets: { label: "Attempts", data: [] } },
  universityStorage: null,
});

export const GetProfStatsCall = async (profId = null) => {
  try {
    const url = profId ? `${getProfStatsURL}?prof_id=${encodeURIComponent(profId)}` : getProfStatsURL;
    const response = await CallAPI({
      url,
      method: "GET",
    });
    const body = response?.data ?? response;
    if (body == null || typeof body !== "object") return defaultProfStats();
    if (body.status >= 400 || (body.message && body.studentsCount === undefined)) return defaultProfStats();
    return body;
  } catch (error) {
    return defaultProfStats();
  }
};

/**
 * Admin: per-university aggregated user stats with smart name normalization
 * and pagination. Returns `null` if unauthorized or on transport failure.
 */
export const GetUniversityInsightsCall = async ({
  page = 1,
  limit = 25,
  search = "",
  sort = "users",
  order = "desc",
  filter = "all",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", String(limit));
    if (sort) params.set("sort", String(sort));
    if (order) params.set("order", String(order));
    if (filter && filter !== "all") params.set("filter", String(filter));
    if (search && String(search).trim()) {
      params.set("search", String(search).trim());
    }
    const response = await CallAPI({
      url: `${getUniversityInsightsURL}?${params.toString()}`,
      method: "GET",
    });
    if (response == null) return null;
    if (typeof response.status === "number" && response.status >= 400) return null;
    return response;
  } catch (_) {
    return null;
  }
};

/**
 * Admin: per-country leaderboard (registrations, purchases, conversion rate).
 * Server-side sort + pagination. Returns `null` on auth failure so the
 * section can hide itself silently for non-admins.
 */
export const GetCountryConversionInsightsCall = async ({
  page = 1,
  limit = 10,
  sort = "registrations",
  order = "desc",
  search = "",
  filter = "all",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("limit", String(limit));
    if (sort) params.set("sort", String(sort));
    if (order) params.set("order", String(order));
    if (filter && filter !== "all") params.set("filter", String(filter));
    if (search && String(search).trim()) {
      params.set("search", String(search).trim());
    }
    const response = await CallAPI({
      url: `${getCountryConversionURL}?${params.toString()}`,
      method: "GET",
    });
    if (response == null) return null;
    if (typeof response.status === "number" && response.status >= 400) return null;
    return response;
  } catch (_) {
    return null;
  }
};

/** Admin: OS version & device model aggregates from user table. */
export const GetDeviceHostsReportCall = async () => {
  try {
    const response = await CallAPI({
      url: getDeviceHostsReportURL,
      method: "GET",
    });
    if (response == null) return null;
    if (typeof response.status === "number" && response.status >= 400) return null;
    return response;
  } catch (_) {
    return null;
  }
};

export const GetStorageSummaryCall = async () => {
  try {
    const response = await CallAPI({
      url: getStorageSummaryURL,
      method: "GET",
    });
    const body = response?.data ?? response;
    if (body == null || typeof body !== "object") {
      return { usedBytes: 0, limitBytes: 0, percent: 0, licenseStart: null, licenseEnd: null };
    }
    return {
      usedBytes: Number(body.usedBytes || 0),
      limitBytes: Number(body.limitBytes || 0),
      percent: Number(body.percent || 0),
      licenseStart: body.licenseStart || null,
      licenseEnd: body.licenseEnd || null,
    };
  } catch (_) {
    return { usedBytes: 0, limitBytes: 0, percent: 0, licenseStart: null, licenseEnd: null };
  }
};
